module.exports = __webpack_public_path__ + "img/bg-main-mobile.50706989.png";